<template>
  <div style="margin-top: 100px;">
    <div style="display: flex; justify-content: space-around;">
      <img
        style="width: 300px; height: 300px;"
        src="https://i.ibb.co/mRhgC2N/Pngtree-computer-online-shopping-4986603.png"
      />
      <form @submit.prevent="registerForm" class="border shadow" style="padding: 50px;">
        <h4>Daftar Sekarang!</h4>
        <p>
          Sudah punya akun? klik
          <router-link class="text-success" :to="{ name: 'Login' }">Disini</router-link>
        </p>
        <div class="form-group">
          <label for="exampleInputEmail1">Email address</label>
          <input
            type="email"
            v-model="emailRegister"
            class="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            placeholder="Enter email"
          />
          <small
            id="emailHelp"
            class="form-text text-muted"
          >We'll never share your email with anyone else.</small>
        </div>
        <div class="form-group">
          <label for="exampleInputPassword1">Password</label>
          <input
            v-model="passwordRegister"
            type="password"
            class="form-control"
            id="exampleInputPassword1"
            placeholder="Password"
          />
        </div>
        <button style="width: 300px;" type="submit" class="btn btn-success">Register</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      emailRegister: "",
      passwordRegister: ""
    };
  },
  methods: {
    registerForm() {
      const email = this.emailRegister;
      const password = this.passwordRegister;
      this.$store.dispatch("registerUser", { email, password });
    }
  }
};
</script>

<style>
</style>